import React, { useState } from 'react';

export default function Combobox({ estyle, cssClass, title, selectedOption, availableOptions, onOptionSelect }) {

    return (
        <select title={title} value={selectedOption && selectedOption.value} onChange={onOptionSelect}
            style={estyle} className={cssClass}>
            {
                availableOptions.map(opt =>
                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                )
            }
        </select>
    );

}